export const SubscriptionPlan = {
  FREE: "1",
};
